import { render, staticRenderFns } from "./PersonalListCreation.vue?vue&type=template&id=488377a4&scoped=true"
import script from "./PersonalListCreation.vue?vue&type=script&lang=js"
export * from "./PersonalListCreation.vue?vue&type=script&lang=js"
import style0 from "./PersonalListCreation.vue?vue&type=style&index=0&id=488377a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488377a4",
  null
  
)

export default component.exports